import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const AglomeracionInventarioBombeosSection = ({aglomeracion}) => {
    return (
        <SectionCard title="Bombeos">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(aglomeracion.stats.bombeos)}
                        tooltipText="Número de estacións de bombeo instaladas na rede"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default AglomeracionInventarioBombeosSection;
